import { render, staticRenderFns } from "./BannerSetModal.vue?vue&type=template&id=00b53146&scoped=true"
import script from "./BannerSetModal.vue?vue&type=script&lang=ts"
export * from "./BannerSetModal.vue?vue&type=script&lang=ts"
import style0 from "./BannerSetModal.vue?vue&type=style&index=0&id=00b53146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b53146",
  null
  
)

export default component.exports